module.exports = __webpack_public_path__ + "static/media/2.c049fb77.png";